export default __webpack_public_path__ + "static/media/Logo.51f42158.svg";